"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElevenLabsEnvironment = void 0;
exports.ElevenLabsEnvironment = {
    Production: "https://api.elevenlabs.io",
    ProductionUs: "https://api.us.elevenlabs.io",
    ProductionEu: "https://api.eu.residency.elevenlabs.io",
    ProductionIndia: "https://api.in.residency.elevenlabs.io",
};
